module.exports = require('./dist/style')
